(function () {
  'use strict';

  function packInfo(value) {
    var text = String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    var single = text.match(/^(?:single|one|1)(?:[ -]?(pack|box|bag|case))?$/);
    if (single) return { count: 1, unit: single[1] || null };
    var match = text.match(/^([2-9]|[1-9][0-9])[ -]?(pack|box|bag|case)(s|es)?$/);
    if (match && (match[3] !== 'es' || match[2] === 'box') &&
        (match[3] !== 's' || match[2] !== 'box')) return { count: Number(match[1]), unit: match[2] };
    match = text.match(/^(pack|box|bag|case) of ([2-9]|[1-9][0-9])$/);
    return match ? { count: Number(match[2]), unit: match[1] } : null;
  }

  function packCount(value) {
    var info = packInfo(value);
    return info ? info.count : null;
  }

  function matchingSingle(product, selected) {
    if (!product || !selected || !Array.isArray(product.variants)) return null;
    if (/\b(variety|sampler|mixed|assorted|assortment|bundle|kit)\b/i.test(
      String(product.title || '') + ' ' + String(selected.title || '')
    )) return null;
    var optionNames = product.options || [];
    var selectedOptions = selected.options || [];
    var packPositions = [];
    selectedOptions.forEach(function (value, index) {
      if (/\b(size|pack|quantity|count)\b/i.test(String(optionNames[index] || '')) && packCount(value) !== null) {
        packPositions.push(index);
      }
    });
    if (packPositions.length !== 1) return null;
    var position = packPositions[0];
    var selectedPack = packInfo(selectedOptions[position]);
    if (!selectedPack || selectedPack.count < 2) return null;
    var candidates = product.variants.filter(function (variant) {
      if (!variant.available || !Number.isInteger(variant.price) || variant.price <= 0) return false;
      var options = variant.options || [];
      var individualPack = packInfo(options[position]);
      if (!individualPack || individualPack.count !== 1) return false;
      if (selectedPack.unit !== 'pack' && individualPack.unit !== 'pack' &&
          selectedPack.unit && individualPack.unit && selectedPack.unit !== individualPack.unit) return false;
      return selectedOptions.every(function (value, index) {
        return index === position || String(options[index] || '').trim().toLowerCase() === String(value || '').trim().toLowerCase();
      });
    });
    return candidates.length === 1 ? { variant: candidates[0], count: selectedPack.count } : null;
  }

  function calculate(product, selected, effectiveCents, quantity, subscription) {
    var match = matchingSingle(product, selected);
    if (!match || !Number.isInteger(effectiveCents) || effectiveCents < 0 ||
        !Number.isInteger(selected.price) || selected.price <= 0) return null;
    var units = Number(quantity);
    if (!Number.isSafeInteger(units) || units < 1 || units > 99) return null;
    if (subscription && effectiveCents > selected.price) return null;
    var baseline = match.variant.price * match.count * units;
    var selectedTotal = effectiveCents * units;
    var totalSaved = baseline - selectedTotal;
    if (totalSaved <= 0) return null;
    return {
      baselineCents: baseline,
      totalSavedCents: totalSaved,
      packSavedCents: Math.max(0, (match.variant.price * match.count - selected.price) * units),
      subscriptionSavedCents: subscription ? (selected.price - effectiveCents) * units : 0,
      percent: Math.floor(totalSaved / baseline * 1000) / 10
    };
  }

  function primaryBadge(savings, subscription) {
    if (!subscription || !savings) return null;
    return 'SAVE ' + String(savings.percent).replace(/\.0$/, '') + '% TOTAL';
  }

  function extraPlanLabel(value) {
    var match = String(value || '').trim().match(/^Save ([0-9]+(?:\.[0-9]+)?)%$/i);
    return match ? 'Extra ' + match[1] + '%' : null;
  }

  function purchaseTotalCents(price, quantity) {
    var units = Number(quantity);
    return Number.isSafeInteger(price) && price >= 0 &&
      Number.isSafeInteger(units) && units >= 1 &&
      Number.isSafeInteger(price * units) ? price * units : null;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { packCount: packCount, matchingSingle: matchingSingle,
      calculate: calculate, purchaseTotalCents: purchaseTotalCents,
      primaryBadge: primaryBadge, extraPlanLabel: extraPlanLabel };
  }
  if (typeof document === 'undefined') return;

  var script = document.currentScript;
  var labels = {
    total: script && script.dataset.totalTemplate || 'Save {amount} total ({percent})',
    baseline: script && script.dataset.baseline || 'vs buying individual packs',
    subscription: script && script.dataset.subscriptionTemplate || 'Includes {amount} extra from subscribing',
    addToCart: script && script.dataset.addToCart || 'Add to cart'
  };
  var shopCurrency = script && script.dataset.shopCurrency || 'USD';
  var syncButtons = script && script.dataset.syncButtons === 'true';

  function centsFromText(text) {
    var match = String(text || '').match(/\$\s*([0-9]{1,3}(?:,[0-9]{3})*|[0-9]+)\.([0-9]{2})/);
    return match ? Number(match[1].replace(/,/g, '')) * 100 + Number(match[2]) : null;
  }

  function priceOf(node) {
    return node ? centsFromText(node.textContent) : null;
  }

  function selectedPurchase(shadow, variantPrice, form, hasPlans) {
    if (!shadow) return hasPlans ? null : { subscription: false, price: variantPrice };
    var checked = shadow.querySelector('input[name="purchaseOption"]:checked');
    var selectedOption = checked && checked.closest('.rc-purchase-option') ||
      shadow.querySelector('.rc-purchase-option[rc-selected]');
    if (!selectedOption) return null;
    var subscription = checked
      ? checked.value === 'subscription'
      : selectedOption.classList.contains('rc-purchase-option__subscription');
    if (!subscription) return { subscription: false, price: variantPrice };
    var plan = form.querySelector('[name="selling_plan"]');
    if (!plan || !plan.value || plan.value === '0') return null;
    var oneTimeInput = shadow.querySelector('input[name="purchaseOption"][value="onetime"]');
    var oneTime = oneTimeInput && oneTimeInput.closest('.rc-purchase-option')
      .querySelector('[part="rc-purchase-option__price"]');
    if (priceOf(oneTime) !== variantPrice) return null;
    var price = priceOf(selectedOption.querySelector('[part="rc-purchase-option__discounted-price"]')) ||
      priceOf(selectedOption.querySelector('[part="rc-purchase-option__price"]'));
    return Number.isInteger(price) ? { subscription: true, price: price } : null;
  }

  function fill(template, amount, percent) {
    return template.replace('{amount}', amount).replace('{percent}', percent);
  }

  function mount() {
    var form = document.querySelector('main form.product-purchase-form, main form.product-form');
    if (!form) return;
    var root = form.closest('.product-form') || form;
    var jsonNode = document.querySelector('[data-product-json], [id^="ProductJson-"]');
    if (!jsonNode) return;
    var product;
    try {
      var parsed = JSON.parse(jsonNode.textContent);
      product = parsed.product || parsed;
    } catch (_) { return; }
    if (!product || !Array.isArray(product.variants)) return;
    var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: shopCurrency
    });
    function money(cents) { return formatter.format(cents / 100); }
    var panel = document.createElement('div');
    panel.className = 'pack-total-savings';
    panel.hidden = true;
    panel.setAttribute('role', 'status');
    panel.setAttribute('aria-live', 'polite');
    var title = document.createElement('strong');
    title.className = 'pack-total-savings__total';
    var baseline = document.createElement('span');
    baseline.className = 'pack-total-savings__baseline';
    baseline.textContent = labels.baseline;
    var secondary = document.createElement('span');
    secondary.className = 'pack-total-savings__subscription';
    panel.append(title, baseline, secondary);
    var anchor = root.querySelector('recharge-subscription-widget') ||
      form.querySelector('.rc-widget-injection-parent, .product-form__variants') ||
      document.querySelector('main .option-selectors');
    if (!anchor) return;
    anchor.insertAdjacentElement('afterend', panel);
    var badgeStates = new WeakMap();

    function syncBadge(widget, offer) {
      var badge = widget && widget.shadowRoot && widget.shadowRoot.querySelector('#rc-subscription-badge');
      if (!badge) return;
      var current = badge.textContent.trim();
      var state = badgeStates.get(badge);
      if (!state) {
        state = { original: current, written: null };
        badgeStates.set(badge, state);
      } else if (current !== state.written && current !== state.original) {
        state.original = current;
      }
      var desired = offer || state.original;
      if (current !== desired) {
        var last = badge.lastChild;
        if (last && last.nodeType === 3) last.nodeValue = desired;
        else badge.appendChild(document.createTextNode(desired));
      }
      state.written = offer;
      widget.classList.toggle('pack-total-savings--primary', Boolean(offer));
    }

    function syncCardDetail(widget, copy) {
      var option = widget && widget.shadowRoot &&
        widget.shadowRoot.querySelector('.rc-purchase-option__subscription');
      if (!option) return false;
      var detail = option.querySelector('.pack-total-savings__in-card');
      if (!copy) {
        if (detail) detail.remove();
        return false;
      }
      if (!detail) {
        detail = document.createElement('span');
        detail.className = 'pack-total-savings__in-card';
        detail.setAttribute('part', 'pack-total-savings__in-card');
        var label = option.querySelector('label');
        if (!label) return false;
        label.insertAdjacentElement('afterend', detail);
      }
      if (detail.textContent !== copy) detail.textContent = copy;
      return true;
    }

    function syncCadence(widget) {
      var plans = widget && widget.shadowRoot &&
        widget.shadowRoot.querySelector('rc-selling-plans');
      var root = plans && plans.shadowRoot;
      if (!root) return;
      root.querySelectorAll('.rc-plans-button__discount').forEach(function (label) {
        var next = extraPlanLabel(label.textContent);
        if (!next) return;
        var textNode = Array.from(label.childNodes).find(function (node) {
          return node.nodeType === 3 && node.nodeValue.trim();
        });
        if (textNode) textNode.nodeValue = next;
        var choice = label.closest('label');
        var input = choice && choice.querySelector('input[type="radio"]');
        var interval = choice && choice.querySelector('.rc-plans-button__interval');
        if (input && interval) input.setAttribute('aria-label',
          interval.textContent.trim() + ', ' + next.toLowerCase() + ' off pack price');
      });
    }

    function activeVariant() {
      var input = form.querySelector('select[name="id"], input[name="id"]');
      return input && product.variants.find(function (item) { return String(item.id) === String(input.value); });
    }
    function quantity() {
      var input = form.querySelector('[name="quantity"]');
      return input ? Number(input.value) : 1;
    }
    function syncPrice(price, variant, units) {
      if (!syncButtons || !variant.available) return;
      var formatted = money(price);
      var total = purchaseTotalCents(price, units);
      var top = document.querySelector('main .product-detail .price-area .current-price');
      var mainButton = form.querySelector('.quantity-submit-row__submit button[type="submit"]');
      var stickyButton = document.querySelector('main .sticky-atc-bar__btn');
      var buttonText = labels.addToCart + (total === null ? '' : ' (' + money(total) + ')');
      if (top && top.textContent.trim() !== formatted) top.textContent = formatted;
      if (mainButton && mainButton.textContent.trim() !== buttonText) mainButton.textContent = buttonText;
      if (stickyButton && stickyButton.textContent.trim() !== buttonText) stickyButton.textContent = buttonText;
    }
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; update(); });
    }
    function update() {
      var widget = root.querySelector('recharge-subscription-widget');
      syncCadence(widget);
      var variant = activeVariant();
      if (!variant || !variant.available || !Number.isInteger(variant.price) ||
          (window.Shopify && Shopify.currency && Shopify.currency.active && Shopify.currency.active !== shopCurrency)) {
        syncBadge(widget, null);
        syncCardDetail(widget, null);
        panel.hidden = true;
        return;
      }
      var purchase = selectedPurchase(widget && widget.shadowRoot, variant.price, form,
        Array.isArray(product.selling_plan_groups) && product.selling_plan_groups.length > 0);
      if (!purchase) { syncBadge(widget, null); syncCardDetail(widget, null); panel.hidden = true; return; }
      var units = quantity();
      syncPrice(purchase.price, variant, units);
      var savings = calculate(product, variant, purchase.price, units, purchase.subscription);
      syncBadge(widget, primaryBadge(savings, purchase.subscription));
      if (!savings) { syncCardDetail(widget, null); panel.hidden = true; return; }
      var percent = String(savings.percent).replace(/\.0$/, '') + '%';
      var heading = fill(labels.total, money(savings.totalSavedCents), percent);
      if (title.textContent !== heading) title.textContent = heading;
      var detail = savings.packSavedCents > 0 && savings.subscriptionSavedCents > 0
        ? fill(labels.subscription, money(savings.subscriptionSavedCents), '')
        : '';
      if (secondary.textContent !== detail) secondary.textContent = detail;
      secondary.hidden = !detail;
      var inCard = purchase.subscription && syncCardDetail(widget,
        heading + ' ' + labels.baseline + (detail ? '. ' + detail : ''));
      if (!purchase.subscription) syncCardDetail(widget, null);
      panel.hidden = Boolean(inCard);
    }
    function bindWidget() {
      var widget = root.querySelector('recharge-subscription-widget');
      if (!widget || !widget.shadowRoot || widget.dataset.packSavingsBound) return false;
      (widget.closest('.shopify-block') || widget).insertAdjacentElement('afterend', panel);
      widget.dataset.packSavingsBound = 'true';
      widget.shadowRoot.addEventListener('change', schedule);
      new MutationObserver(schedule).observe(widget.shadowRoot, {
        childList: true, subtree: true, characterData: true, attributes: true,
        attributeFilter: ['rc-selected', 'checked']
      });
      schedule();
      return true;
    }
    form.addEventListener('change', schedule);
    form.addEventListener('input', schedule);
    form.addEventListener('click', schedule);
    document.addEventListener('variant:changed', schedule);
    document.addEventListener('rc-widget-ready', function () { bindWidget(); schedule(); });
    if (syncButtons) {
      var priceArea = document.querySelector('main .product-detail .price-area');
      var buttons = document.querySelector('main .quantity-submit-row__submit');
      var sticky = document.querySelector('main .sticky-atc-bar__btn');
      [priceArea, buttons, sticky].forEach(function (target) {
        if (target) new MutationObserver(schedule).observe(target, { childList: true, characterData: true, subtree: true });
      });
    }
    if (!bindWidget()) {
      var attempts = 0;
      var timer = setInterval(function () {
        attempts++;
        if (bindWidget() || attempts >= 40) clearInterval(timer);
      }, 250);
    }
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
